export default "__VITE_ASSET__AuwfnTTV__"